import {
  enableSessionCache,
  prefetchSessionVerification,
} from 'stores/sessionStore';
import { useSupportUserStore } from 'stores/supportUserStore';

let booted = false;

/**
 * The recruiter app's session boot, run once per page load: the entry calls it
 * as soon as it evaluates, so the verify request overlaps the app chunk
 * download, and App.tsx calls it again (a no-op). Kept free of i18next, Mantine
 * and the recruiter namespaces, since it runs in the entry.
 */
export const bootRecruiterSession = (): void => {
  if (booted) return;
  booted = true;
  enableSessionCache();
  // First: the verify headers (and later the cache check) read the support store.
  useSupportUserStore.getState().hydrate();
  prefetchSessionVerification();
};
